<script setup>
/**
 * Format
 * https://redcircle.com/shows/04fc3587-95c1-4b7a-8da1-60008e7bdfef/episodes/43e27b56-be63-48ff-bf8e-bd0f3514dcff
 * https://redcircle.com/embedded-player/sh/04fc3587-95c1-4b7a-8da1-60008e7bdfef/ep/56b65bde-6766-4417-a11b-f310937c4654
 */
const props = defineProps({
    data: { type: Object, default: () => {} },
    coverColor: {
        type: String,
        default: '',
    },
});

const iframeURL = props.data.data.embeddedPodcast
    .replace('https://redcircle.com/shows/', 'https://redcircle.com/embedded-player/sh/')
    .replace('/episodes/', '/ep/');
</script>

<template>
    <div class="PodcastEmbedded Page__right is-s">
        <iframe
            class="PodcastEmbedded__iframe w-full"
            :src="iframeURL"
            height="170"
            frameborder="0"
        />
    </div>
</template>
